import { useEffect } from 'react';
import { BodyRegular, H1 } from '@components/atoms/typography';

type ReviewsCarouselType = { header?: string; subHeader?: string };

const ReviewsCarousel = ({ header, subHeader }: ReviewsCarouselType) => {
  useEffect(() => {
    if (window.Trustpilot) {
      const widgets = document.getElementsByClassName('trustpilot-widget');
      Array.from(widgets).forEach((widget) => {
        window.Trustpilot.loadFromElement(widget);
      });
    }
  }, []);

  return (
    <div className="bg-neutral-100">
      <div className="container mx-auto px-8 md:px-16 py-6 md:py-16 md:pt-8">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-5 md:mb-3">
          {header && subHeader && (
            <div>
              <H1>{header}</H1>
              <BodyRegular className="pb-8 max-w-[770px]">
                {subHeader}
              </BodyRegular>
            </div>
          )}
        </div>
        <div>
          <div
            className="trustpilot-widget"
            data-locale="en-GB"
            data-template-id="54ad5defc6454f065c28af8b"
            data-businessunit-id="61e6f3bfa6bec4c5bbb7a049"
            data-style-height="240px"
            data-style-width="100%"
            data-stars="4,5"
            data-review-languages="en"
          >
            <a
              href="https://uk.trustpilot.com/review/fantasyfootballhub.co.uk"
              target="_blank"
              rel="noopener noreferrer"
            >
              Trustpilot
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewsCarousel;
